// https://github.com/ua-parser/uap-core/blob/master/regexes.yaml#L96
const fbre = RegExp('\\[FB.*;(FBAV)/(\\d+)(?:.(\\d+)(?:.(\\d+))?)?');

export const isFacebookApp = (ua: string) => fbre.test(ua);
